export const loginrequest = payload => ({ type: 'LOGIN_REQUEST', payload })
export const deletePost = payload => ({ type: 'DELETE_POST', payload })
export const stateDeletePostt = payload => ({ type: 'STATE_DELETE_POST', payload })